import { StyleSheet } from 'aphrodite';
import { brandPrimary, darkGrayFontColor } from '../../../styles/colors';
import { CssSelectors } from '../../../styles/styles';

const searchHeaderHeight = 90;

export const styleSheet = StyleSheet.create({
	clear: {
		color: brandPrimary,
		marginLeft: 10,
	},
	dateSelect: {
		width: 220,
		borderRadius: 6,
		marginLeft: 10,
	},
	exportButton: {
		marginLeft: 10,
	},
	exportDialogCheckboxRow: {
		alignItems: 'center',
		cursor: 'pointer',
		display: 'flex',
		gap: 8,
	},
	exportConfirmationNote: {
		marginTop: 8,
	},
	exportDialogDescription: {
		color: darkGrayFontColor,
		fontSize: 13,
		lineHeight: 1.4,
		marginLeft: 28,
		marginTop: 4,
	},
	exportTooLargeSuggestions: {
		color: darkGrayFontColor,
		fontSize: 13,
		lineHeight: 1.5,
		marginTop: 4,
		paddingLeft: 20,
	},
	exportTooLargeSuggestionsHeading: {
		fontWeight: 600,
		marginTop: 16,
	},
	filterSelect: {
		width: 250,
		marginLeft: 10,
		borderRadius: 6,
	},
	filterSelectOption: {
		width: 248,
	},
	note: {
		':not(:last-child)': {
			marginBottom: 15,
		},
		boxSizing: 'border-box',
		width: 'calc(100% - 5px)',
	},
	notesList: {
		boxSizing: 'border-box',
		height: `calc(100% - ${searchHeaderHeight}px)`,
		maxWidth: '100%',
		overflowY: 'auto',
		padding: '0 5px 20px 0',
		width: '100%',
	},
	searchContainer: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-end',
	},
	searchField: {
		borderRadius: 6,
		width: 360,
		...CssSelectors.allChildren(
			{
				marginLeft: 10,
			},
			'input[type="text"]'
		),
	},
	searchHeader: {
		alignItems: 'center',
		background: '#fff',
		display: 'flex',
		height: searchHeaderHeight,
		justifyContent: 'space-between',
	},
	searchHeaderWrap: {
		display: 'flex',
	},
	searchIcon: {
		height: 16,
		width: 16,
	},
	sortSelect: {
		width: 320,
		borderRadius: 6,
	},
});
